import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import jsPDF from 'jspdf';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { DataService } from 'src/app/Service/data.service';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-print-ventas-cliente-anual',
  templateUrl: './print-ventas-cliente-anual.component.html',
  styleUrls: ['./print-ventas-cliente-anual.component.css']
})
export class PrintVentasClienteAnualComponent implements OnInit {

  public ventasData: any[] = [];
  public filtrosAplicados: any = {};
  public totalRegistros: number = 0;
  public today = new Date();
  public filtro: Filtro = new Filtro();

  @ViewChild('pagina', null) public pagina: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;

  constructor(
    private sanitizer: DomSanitizer,
    private data: DataService,
    private reportViewer: ReportViewerService,
    private datePipe: DatePipe,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  /**
   * Obtiene los datos del reporte desde el backend
   */
  GetData(filtro: any) {
    console.log('📤 Solicitando reporte anual con filtros:', filtro);

    this.data.Post('ventas-por-mes', filtro).subscribe({
      next: (r: any) => {
        console.log('📥 Respuesta del backend:', r);

        if (r && r.datos) {
          this.ventasData = r.datos;
          this.filtrosAplicados = r.filtros_aplicados;
          this.totalRegistros = r.total_registros;

          this.cdr.detectChanges();

          setTimeout(() => {
            const blob = this.generarPDF();

            if (blob) {
              // ✅ CAMBIADO: año → anio
              const anio = this.filtrosAplicados.anio || new Date().getFullYear();
              const tipoCliente = (this.filtrosAplicados.tipo_cliente && this.filtrosAplicados.tipo_cliente.descripcion) || 'Todos';
              const tipoBalon = (this.filtrosAplicados.tipo_balon && this.filtrosAplicados.tipo_balon.nombre) || 'Todos';

              this.reportViewer.mostrarPDF(
                blob,
                'Reporte de Ventas Anuales por Cliente',
                `reporte_ventas_anual_${anio}_${tipoCliente}_${tipoBalon}.pdf`
              );
            }
          }, 0);
        } else {
          console.warn("No se obtuvieron datos válidos del backend");
          this.data.notify("No se encontraron datos para el reporte", "Información", this.data.alertType.info);
        }
      },
      error: (err: any) => {
        console.error("Error al obtener datos del reporte:", err);
        this.data.notify("Error al generar el reporte", "Error", this.data.alertType.error);
      }
    });
  }

  generarPDF(): Blob | null {
    const doc = new jsPDF('landscape');
    
    const addHeader = (pageNumber: number) => {
      // Título principal
      doc.setFontSize(14);
      doc.text('REPORTE DE VENTAS ANUALES POR CLIENTE', 100, 15);
      const textWidth = doc.getTextWidth('REPORTE DE VENTAS ANUALES POR CLIENTE');
      doc.setLineWidth(0.5);
      doc.line(100, 16, 100 + textWidth, 16);

      // Información de filtros
      doc.setFontSize(9);
      let infoY = 22;

      if (this.filtrosAplicados.anio) {
        doc.text(`Año: ${this.filtrosAplicados.anio}`, 10, infoY);
        infoY += 0;
      }

      if (this.filtrosAplicados.fecha_inicio && this.filtrosAplicados.fecha_fin) {
        doc.text(
          `Periodo: ${this.formatFecha(this.filtrosAplicados.fecha_inicio, 'dd-MM-yyyy')} al ${this.formatFecha(this.filtrosAplicados.fecha_fin, 'dd-MM-yyyy')}`,
          10,
          infoY
        );
        infoY += 4;
      }

      if (this.filtrosAplicados.tipo_cliente) {
        doc.text(
          `Tipo Cliente: ${this.filtrosAplicados.tipo_cliente.descripcion}`,
          35,
          infoY
        );
        infoY += 4;
      }

      if (this.filtrosAplicados.tipo_balon) {
        doc.text(
          `Tipo Balón: ${this.filtrosAplicados.tipo_balon.nombre}`,
          10,
          infoY
        );
        infoY += 4;
      }

      // Fecha de generación y número de página
      doc.text(
        `Generado: ${this.formatFecha(this.today, 'dd-MM-yyyy HH:mm')}`,
        220,
        22
      );

      doc.text(`Página ${pageNumber}`, 260, 15);

      doc.setFontSize(10);
    };

    // Preparar datos para la tabla
    const tableRows: any[] = [];
    const meses = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];

    // Construir filas de datos
    this.ventasData.forEach((venta: any) => {
      const row: any[] = [];
      row.push(venta.cliente_nombre || '');

      meses.forEach(mes => {
        row.push(venta[mes] || 0);
      });

      row.push(venta.total || 0);
      tableRows.push(row);
    });

    // Encabezados de la tabla
    const headerRow = [
      'CLIENTE',
      'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN',
      'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC',
      'TOTAL'
    ];

    // Estilos de columna
    const columnStyles: any = {
      0: { halign: 'left', cellWidth: 60 }
    };

    for (let i = 1; i <= 12; i++) {
      columnStyles[i] = { halign: 'center', cellWidth: 15 };
    }

    columnStyles[13] = { halign: 'center', cellWidth: 18, fontStyle: 'bold' };
    
    let marginTop = 25;
    if (this.filtrosAplicados.fecha_inicio) marginTop += 4;
    //if (this.filtrosAplicados.tipo_cliente) marginTop += 4;
    if (this.filtrosAplicados.tipo_balon) marginTop += 4;
    
    (doc as any).autoTable({
      head: [headerRow],
      body: tableRows,
      startY: marginTop,
      margin: {
        horizontal: 10,
        top: marginTop
      },
      theme: 'grid',
      columnStyles,
      styles: {
        fontSize: 8,
        cellPadding: 1.5,
        overflow: 'linebreak'
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'center',
        fontSize: 8
      },
      didParseCell: (data: any) => {
        // Resaltar fila de totales
        if (data.row.index === tableRows.length - 1 && data.section === 'body') {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fillColor = [240, 240, 240];

          if (data.column.index === 13) {
            data.cell.styles.fillColor = [255, 235, 59];
            data.cell.styles.textColor = [0, 0, 0];
          }
        }

        
        if (data.section === 'body' &&
          data.column.index > 0 &&
          data.column.index < 13 &&
          data.row.index < tableRows.length - 1) {
          const valor = parseInt(data.cell.raw);
          if (valor > 0) {
            data.cell.styles.fillColor = [200, 230, 201];
          }
        }
      },
      didDrawPage: (data: any) => {
        addHeader(data.pageNumber);
      }
    });

    return doc.output('blob');
  }
  /**
   * Formatea una fecha
   */
  formatFecha(fecha: Date | string, format: string): string {
    return this.datePipe.transform(fecha, format) || '';
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }

}
